<template>
    <hr class="dropdown-divider">
</template>